import { useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom"

import { useAuth } from "~/store/auth-context"

export const AdminAuthGuard = () => {
  const navigate = useNavigate()
  const { user, isAdmin } = useAuth()

  useEffect(() => {
    if (!user) return navigate("/login")
    if (!isAdmin) navigate("/")
  }, [navigate, user, isAdmin])

  if (!user || !isAdmin) return null

  return <Outlet />
}
